<template>
  <div class="register-container">
    <!-- 左侧背景区域 -->
    <div class="left-section">
      <div class="background-image"></div>
      <!-- 功能内容区域 -->
      <div class="content-blocks">
        <!-- 智能选股 -->
        <div class="content-block">
          <div class="block-header">
            <img src="../../assets/register/znxg@2x.png" alt="智能选股" class="block-icon">
            <h3 class="block-title">智能选股</h3>
          </div>
          <p class="block-description">运用机器学习算法，基于近三年股票公开数据对全市场股票进行每
            日自动筛选，提供模拟训练基础股票池。</p>
        </div>

        <!-- 模拟交易 -->
        <div class="content-block">
          <div class="block-header">
            <img src="../../assets/register/mnjy@2x.png" alt="模拟交易" class="block-icon">
            <h3 class="block-title">模拟交易</h3>
          </div>
          <p class="block-description">支持模拟资金设置、佣金规费设置、提供普通交易、条件单等操作
            方式，完全仿真实际股票交易环境，按标准规则撮合成交。</p>
        </div>

        <!-- 投资分析 -->
        <div class="content-block">
          <div class="block-header">
            <img src="../../assets/register/tzfx@2x.png" alt="投资分析" class="block-icon">
            <h3 class="block-title">投资分析</h3>
          </div>
          <p class="block-description">对账户交易习惯、频次、胜率等进行全量全周期回顾分析，及时发
            现和改善操作问题，提升训练效果。</p>
        </div>

        <!-- 下载按钮 -->
        <div class="download-button-container">
          <button class="download-button" @click="download(version_new_url)">下载Windows端</button>
        </div>
      </div>
    </div>

    <!-- 右侧注册表单区域 -->
    <div class="right-section">
      <div v-show="loginCode == undefined" class="register-form">
        <div class="form-container">

          <!-- Logo区域 -->
          <div class="logo-container" @click="to_index">
            <img src="../../assets/register/yblogo@2x.png" alt="悦宝logo" class="logo">


          </div>


          <!-- 注册标题 -->
          <div class="title">注册</div>
          
          <!-- 扫码注册提示（仅在扫码且邀请码有效时显示） -->
          <div v-if="isFromQRCode && inviteCodeValid" class="qr-register-tip">
            <span class="tip-label">扫码注册</span>
            <span class="tip-text">将获得 {{ inviteCodeInfo?.bonus_balance }} 模拟资金</span>
          </div>

          <!-- 表单输入区域 -->
          <div class="form-inputs">
            <input class="register_input" type="text" placeholder="请输入用户名" v-model="uname"/>
            <input class="register_input" type="text" placeholder="请输入手机号" v-model="uphone"/>

            <input class="register_input" type="password" placeholder="请设置密码" v-model="upwd"/>
            <input class="register_input" type="password" placeholder="请再次输入密码" v-model="upwd2"/>
            
            <!-- 隐藏邀请码输入框，仅在内部使用 -->
            <!-- <input class="register_input" type="text" placeholder="请输入推荐人代码" v-model="referralCode"/> -->
            
            <div class="verification-container">
              <input class="register_input verification-input" type="text" placeholder="请输入图形验证码"
                     v-model="captcha_code"/>
              <VerifyCode
                  class="code verification-img"
                  :yVerifyCode="VerifyCodeStr"
                  @click="updateVerifyCode"
              ></VerifyCode>
            </div>

            <div class="verification-container">
              <input class="register_input verification-input" type="text" placeholder="请输入短信验证码"
                     v-model="verificationCode"/>
              <button class="verification-btn" :disabled="isVerificationDisabled" @click="getVerificationCode">
                {{ verificationBtnText }}
              </button>
            </div>
            <button :class="zcBtnClass" :disabled="isButtonDisabled" @click="register">注册</button>
            <div class="registerBox">
              <span class="index_link" @click="to_index">返回首页</span>
              <span class="fhdl" @click="to_login">已有账号，<span class="login-text">去登录</span></span>
            </div>
          </div>
        </div>

        <!-- 底部信息 -->
        <div class="bottom-title">
          <div style="margin-bottom: 10px">本网站不提供任何投资咨询服务、投资顾问服务、投资理财服务</div>
          <div>Copyright ©2025悦宝金服-上海悦宝互联网金融信息服务股份有限公司</div>
        </div>
      </div>
    </div>
  </div>

  <!--  <div class="zx_qr_box" v-if="zx_qr_show" style="text-align: center">-->
  <!--    <img style="width: 100px" src="../../assets/register/jszc_qr.png" alt="">-->
  <!--    <span style="display: block;font-size: 12px;line-height: 8px">添加客服为您服务</span>-->
  <!--  </div>-->

  <!--  <div class="zx_mr_box" v-if="!zx_qr_show" @mouseover="zxMouseOver" @mouseout="zxMouseOut">-->
  <!--  </div>-->
  <!--  <div class="zx_xf_box" v-if="zx_qr_show" @mouseover="zxMouseOver" @mouseout="zxMouseOut">-->
  <!--  </div>-->
</template>

<script>
import {getUrlParam} from "@/utils/GetUrlParam";
import {ElMessage} from "element-plus";
import {menu_limits, asyncRoutes, addRouter, setupRouter} from "@/router";
import {
  register, send_register_sms, soft_list
} from "@/api/system/system.js";
import {getCurrentInstance} from "vue";
import VerifyCode from "@/components/VerifyCode/verifyCode.vue";

export default {
  components: {VerifyCode},
  data() {
    return {
      isButtonDisabled: false,
      zcBtnClass: "button-default",
      zx_qr_show: false,
      uphone: "",
      uname: "",
      verificationCode: "",
      upwd: "",
      upwd2: "",
      referralCode: "",
      isVerificationDisabled: false,
      verificationBtnText: "获取验证码",
      version_new_url: "",
      countdown: 0,
      captcha_code: "",
      VerifyCodeStr: "",
      conf: {
        version: getCurrentInstance()?.appContext.config.globalProperties
            .$g_version,
      },
      url: "",
      loginCode: undefined,
      // 新增：扫码注册相关字段
      isFromQRCode: false,      // 是否来自扫码注册
      inviteCodeValid: true,    // 邀请码是否有效
      inviteCodeInfo: null,     // 邀请码详细信息
    };
  },
  mounted() {

  },
  created() {
    // 方式 1: 从 sessionStorage 获取邀请码（安全，URL 不可见）
    const storedCode = sessionStorage.getItem('invitation_code');
    if (storedCode) {
        this.referralCode = storedCode;
        this.isFromQRCode = true;
        
        // 验证邀请码有效性
        this.validateInviteCode(storedCode);
    } else {
        // 无邀请码，默认为普通注册
        this.isFromQRCode = false;
    }
    
    this.updateVerifyCode()
  },
  watch: {

    $route: {
      handler(route) {
        this.loginCode = undefined;
        this.redirect = (route.query && route.query.redirect) || "/";
      },
      immediate: true,
    },
  },
  methods: {
    download(url) {
      this.$router.push("/download");
      // if (!url) {
      //   ElMessage.warning("下载地址不存在");
      //   return;
      // }
      // // 以新窗口打开，便于浏览器直接下载
      // window.open(url, "_blank");
    },
    // get_soft_list(){
    //   soft_list().then(
    //     (res) => {
    //       this.version_new_url = res.data.data.win[0].download_url;
    //
    //
    //     },
    //     (error) => {
    //       ElMessage({
    //         showClose: true,
    //         message: error,
    //         type: "warning",
    //       });
    //     }
    //   );
    // },

    zxMouseOver() {
      this.zx_qr_show = true;
    },
    zxMouseOut() {
      this.zx_qr_show = false;
    },
    register() {
      let data = {
        user_guid: this.uphone,
        username: this.uname,
        password: this.upwd,
        verify_code: this.verificationCode,
        invitation_code: this.referralCode
      };
      if (!this.uname) {
        ElMessage({
          showClose: true,
          message: "请输入您的用户名",
          type: "warning",
        });
        return;
      }
      if (!this.uphone) {
        ElMessage({
          showClose: true,
          message: "请输入您的手机号",
          type: "warning",
        });
        return;
      }
      if (!this.verificationCode) {
        ElMessage({
          showClose: true,
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      if (!this.upwd) {
        ElMessage({
          showClose: true,
          message: "请输入您的密码",
          type: "warning",
        });
        return;
      }
      if (!this.upwd2) {
        ElMessage({
          showClose: true,
          message: "请输入您的确认密码",
          type: "warning",
        });
        return;
      }
      if (this.upwd2 != this.upwd) {
        ElMessage({
          showClose: true,
          message: "两次输入密码不一致",
          type: "warning",
        });
        return;
      }
      // const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}$/; //密码测试
      // if (!reg.test(this.upwd2)) {
      //   ElMessage({
      //     showClose: true,
      //     message: "密码必须包含大小写字母、数字、特殊字符长度 8-16 位之间",
      //     type: "warning",
      //   });
      //   return;
      // }
    
      // 如果邀请码无效，不传递给后端（降级为普通注册）
      if (!this.inviteCodeValid && this.referralCode) {
          delete data.invitation_code;
      }
    
      register(data).then(
          (res) => {
            if (res.data.status === 'success') {
              if (res.data.message === "verify_code_error") {
                ElMessage({
                  showClose: true,
                  message: "验证码错误",
                  type: "error",
                });
              } else {
                console.log("==register_res==", res.data.data);
                ElMessage({
                  showClose: true,
                  // message: res.data.message,
                  message: "注册成功",
                  type: "success",
                });
                    
                // 如果是扫码注册且邀请码有效，显示额外提示
                if (this.isFromQRCode && this.inviteCodeValid) {
                    ElMessage.success('注册成功！已获得扫码奖励资金');
                }
                    
                this.isButtonDisabled = true;
                this.zcBtnClass = "button-dissable";
    
                // 注册成功后跳转到登录页面
                setTimeout(() => {
                  this.$router.push("/Login");
                }, 2000);
    
              }
    
            } else {
              ElMessage({
                showClose: true,
                message: res.data.message,
                type: "error",
              });
            }
    
          },
          (error) => {
            console.log(error);
            ElMessage({
              showClose: true,
              message: "注册失败",
              type: "error",
            });
          }
      );
    },

    to_login() {
      this.$router.push("/Login");
    },
    to_index() {
      this.$router.push("/index");
    },

    getVerificationCode() {
      if (!this.uphone) {
        ElMessage({
          showClose: true,
          message: "请先输入手机号",
          type: "warning",
        });
        return;
      }

      // 手机号格式验证
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.uphone)) {
        ElMessage({
          showClose: true,
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      console.log("图形验证码值:", this.captcha_code); // 添加调试日志
      if (!this.captcha_code) {
        ElMessage({
          showClose: true,
          message: "请先输入图形验证码",
          type: "warning",
        });
        return;
      }

      if (this.captcha_code.toUpperCase() != this.VerifyCodeStr.toUpperCase()) {
        ElMessage({
          showClose: true,
          message: "图形验证码错误",
          type: "warning",
        });
        return;
      }




      var data = {
        "tel_num": this.uphone
      }
      // 这里应该调用获取验证码的API
      send_register_sms(data).then(
          (res) => {
            console.log("==send_register_sms==", res);
            if (res.data.code === 0) {
              ElMessage({
                showClose: true,
                message: "验证码已发送",
                type: "success",
              });


            } else {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }

          },
          (error) => {
            console.log(error);
            ElMessage({
              showClose: true,
              message: "验证码发送失败",
              type: "error",
            });
          }
      );


      // 开始倒计时
      this.startCountdown();
    },

    startCountdown() {
      this.isVerificationDisabled = true;
      this.countdown = 60;
      this.verificationBtnText = `${this.countdown}秒后重新获取`;

      const timer = setInterval(() => {
        this.countdown--;
        this.verificationBtnText = `${this.countdown}秒后重新获取`;

        if (this.countdown <= 0) {
          clearInterval(timer);
          this.isVerificationDisabled = false;
          this.verificationBtnText = "获取手机验证码";
        }
      }, 1000);
    },
    updateVerifyCode() {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let randomString = "";
        for (let i = 0; i < 4; i++) {
          randomString += letters[Math.floor(Math.random() * letters.length)];
        }
        this.VerifyCodeStr = randomString;
      },

      // 新增：验证邀请码有效性
      async validateInviteCode(code) {
        try {
          // 调用后端验证接口
          const { validate_invite_code } = require("@/api/system/system.js");
          const res = await validate_invite_code({ invite_code: code });
          
          if (res.data.status === 'success') {
            this.inviteCodeValid = res.data.data.is_valid;
            this.inviteCodeInfo = res.data.data;
            
            if (!this.inviteCodeValid) {
              // 邀请码无效，提示用户并提供选择
              this.$confirm('该邀请码已过期或无效，是否切换为普通注册方式？', '提示', {
                confirmButtonText: '切换为普通注册',
                cancelButtonText: '保留邀请码',
                type: 'warning',
                duration: 10000 // 10 秒后自动关闭
              }).then(() => {
                // 用户选择切换为普通注册
                this.switchToNormalRegister();
              }).catch(() => {
                // 用户选择保留，不清空，允许继续尝试
                ElMessage({
                  showClose: true,
                  message: '您可以继续使用当前邀请码，但注册时可能无法享受优惠资金',
                  type: 'info'
                });
              });
              
              // 注意：这里不立即清空，等待用户选择
            } else {
              // 邀请码有效，提示用户
              ElMessage({
                showClose: true,
                message: `扫码注册可获得 ${this.inviteCodeInfo.bonus_balance} 模拟资金`,
                type: 'success'
              });
            }
          } else {
            // 验证接口返回错误
            console.error('邀请码验证失败:', res.data.message);
            // 降级为普通注册
            this.inviteCodeValid = false;
            this.switchToNormalRegister();
          }
        } catch (error) {
          console.error('邀请码验证异常:', error);
          // 验证失败不影响注册流程，降级为普通注册
          this.inviteCodeValid = false;
          // 网络错误等情况，给用户选择
          this.$confirm('邀请码验证失败（可能是网络问题），是否切换为普通注册方式？', '提示', {
            confirmButtonText: '切换为普通注册',
            cancelButtonText: '保留邀请码',
            type: 'warning'
          }).then(() => {
            this.switchToNormalRegister();
          }).catch(() => {
            // 保留邀请码
          });
        }
      },
      
      // 切换为普通注册模式
      switchToNormalRegister() {
        // 清空邀请码相关数据
        this.referralCode = '';
        this.isFromQRCode = false;
        this.inviteCodeValid = false;
        this.inviteCodeInfo = null;
        
        // 清除 sessionStorage 中的邀请码
        sessionStorage.removeItem('invitation_code');
        
        ElMessage({
          showClose: true,
          message: '已切换为普通注册方式',
          type: 'info'
        });
      },

  },
};
</script>
<style scoped>
.register-container {
  display: flex;
  width: 100%;
  min-height: 100vh;
  font-size: 14px;
  flex-direction: row;
}

@media (max-width: 768px) {
  .register-container {
    flex-direction: column-reverse;
    height: auto;
  }

  .left-section, .right-section {
    flex: none;
    width: 100%;
    min-height: auto;
  }

  .right-section {
    padding: 40px 20px 60px; /* 增加底部内边距，确保底部信息有足够空间 */
    flex-direction: unset !important;
    justify-content: unset !important;
    align-items: unset !important;
    position: relative; /* 为底部信息提供定位上下文 */
    min-height: 100vh; /* 确保右侧区域至少占满屏幕高度 */
    box-sizing: border-box;
  }

  .left-section {
    padding: 40px 0px;
    flex-direction: unset !important;
    justify-content: unset !important;
    align-items: unset !important;
  }

  .register-form {
    width: 100%;
    max-width: 400px; /* 限制最大宽度 */
    margin: 0 auto; /* 居中显示 */
    padding: 0 !important; /* 移除左右内边距，由 right-section 控制 */
    display: flex;
    flex-direction: column;
    flex: 1; /* 让表单占据可用空间 */
  }

  .form-container {
    flex: 0 0 auto; /* 不拉伸，根据内容自适应 */
    width: 100%;
  }

  .content-blocks {
    max-width: 100%;
    padding: 10px !important;
  }

  .content-block {
    margin-bottom: 30px;
  }

  .block-description {
    margin-left: 57px;
  }

  .download-button-container {
    margin-left: 57px;
  }

  .download-button {
    width: 100%;
    max-width: 300px;
  }

  .title {
    margin-top: 20px;
  }

  .logo-container {
    position: relative;
    top: auto;
    margin-bottom: 20px;
  }

  .bottom-title {
    margin-top: 40px; /* 增加与表单的间距 */
    width: 100%;
    box-sizing: border-box;
  }
  
  /* 移动端输入框优化 */
  .register_input {
    height: 44px; /* 移动端更适合触摸的高度 */
    font-size: 16px; /* 防止 iOS 自动缩放 */
  }
  
  /* 按钮优化 */
  button {
    height: 44px;
    -webkit-tap-highlight-color: transparent; /* 移除点击高亮 */
  }
  
  /* 验证码容器优化 */
  .verification-container {
    flex-wrap: wrap; /* 允许换行 */
  }
  
  .verification-btn {
    width: auto;
    min-width: 100px;
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .logo{
    height: 20px;
    width: 100px;
  }
  .register_input, .verification-btn, button {
    height: 36px;
  }

  .block-header {
    margin-bottom: 10px;
  }

  .block-title {
    font-size: 18px;
  }

  .block-description {
    font-size: 13px;
  }
  
  /* 小屏幕进一步优化 */
  .register-container {
    padding: 0;
  }
  
  .right-section {
    padding: 20px 15px 40px; /* 保持底部内边距 */
  }
  
  .logo {
    height: 28px;
  }
  
  .title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .bottom-title {
    font-size: 11px;
    padding: 15px 10px 30px; /* 增加底部内边距防止重叠 */
  }
  
  /* 确保 registerBox 在小屏幕上的显示 */
  .registerBox {
    flex-direction: column;
    gap: 10px;
  }
  
  .index_link, .fhdl {
    width: 100%;
    text-align: center; /* 改为居中对齐 */
  }
}

/* 触摸优化 */
.register_input:focus,
button:active,
.verification-btn:active {
  transform: scale(0.98);
  transition: transform 0.1s;
}

/* 禁用双击缩放 */
* {
  touch-action: manipulation;
}

.left-section {
  flex: 1;
  position: relative;
  background-color: #0053BF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/register/zcbg@1x.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.content-blocks {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 500px;
  padding: 0 40px;
}

.content-block {
  background: transparent;
  margin-bottom: 40px;
  text-align: left;
}

.block-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.block-icon {
  width: 42px;
  height: 42px;
  margin-right: 15px;
  flex-shrink: 0;
}

.block-title {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}

.block-description {
  color: #fff;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  margin-left: 57px; /* 52px icon width + 15px margin */
  text-align: left;
}

.download-button-container {
  margin-top: 20px;
  margin-left: 57px; /* 与投资分析标题左对齐 */

}

.download-button {
  width: 300px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2); /* 20%不透明度 */
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  position: relative;
}

.register-form {
  width: 500px;
  padding: 40px;
  padding-top: 0;
}

.form-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.logo-container {
  position: absolute;
  top: 30px;
  z-index: 10;
  cursor: pointer;
}

.logo {
  height: 32px;
  width: auto;
}


.form-inputs {
  flex: 1;
}

.title {
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  color: #BA0B0B;
  text-align: left;
  margin-bottom: 30px;
  margin-top: 50px;
}

/* 注册类型提示样式 */
.qr-register-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 20px;
  padding: 10px 15px;
  border-radius: 4px;
  background-color: #f0f9eb;
  font-size: 14px;
  box-sizing: border-box; /* 确保 padding 不增加总宽度 */
}

.qr-register-tip .tip-label {
  color: #67c23a;
  font-weight: 600;
  white-space: nowrap; /* 防止标签换行 */
  flex-shrink: 0; /* 防止标签被压缩 */
}

.qr-register-tip .tip-text {
  color: #67c23a;
  font-weight: 500;
  flex: 1; /* 让文字占据剩余空间 */
  text-align: left;
  overflow: hidden; /* 防止文字溢出 */
  text-overflow: ellipsis; /* 超长时显示省略号 */
  white-space: nowrap; /* 不换行 */
}

.register_input {
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  outline: none;
  margin-bottom: 20px;
  border: 1px solid #E7E7E7;
  border-radius: 4px;
  font-size: 14px;
  padding: 0 10px;
  color: #040404;
  font-family: "PingFang", sans-serif;
  transition: border-color 0.3s ease;
}

.register_input:focus {
  border-color: #BA0B0B;
}

.verification-container {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.verification-input {
  flex: 1;
  margin-bottom: 0;
}

.verification-btn {
  width: 120px;
  height: 40px;
  background-color: #fff;
  color: #BA0B0B;
  border: 1px solid #BA0B0B;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.verification-btn:hover:not(:disabled) {
  background-color: #BA0B0B;
  color: #fff;
}

.verification-btn:disabled {
  background-color: #fff;
  color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}

input::-webkit-input-placeholder {
  color: #999;
}

input:-moz-placeholder {
  color: #999;
}

input::-moz-placeholder {
  color: #999;
}

input:-ms-input-placeholder {
  color: #999;
}

button {
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  outline: none;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-family: "PingFang", sans-serif;
  transition: background-color 0.3s ease;
}

.button-default {
  background-color: #BA0B0B;
  margin-top: 10px;
  margin-bottom: 20px;
}

.button-default:hover {
  background-color: #BA0B0B;
}

.button-dissable {
  background-color: #909399;
  margin-top: 10px;
  margin-bottom: 20px;
  cursor: not-allowed;
}

.button-auth {
  background-color: rgb(83, 86, 255);
}

.bottom-title {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #ADADAD;
  text-align: center;
  line-height: 1.5;
  padding: 0 40px;
}

/* 移动端覆盖 bottom-title 样式 */
@media (max-width: 768px) {
  .bottom-title {
    position: static; /* 完全静态定位，跟随文档流 */
    margin-top: auto; /* 推到底部 */
    font-size: 12px;
    color: #ADADAD;
    text-align: center;
    line-height: 1.6;
    padding: 20px 40px 40px; /* 增加底部内边距，确保不重叠 */
    width: 100%;
    box-sizing: border-box;
  }
}

.el-message {
  font-size: 14px;
  min-width: 300px;
}

  .index_link {
    color: #777777;
    display: inline-block; /* 改为 inline-block 以适应移动端 */
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    margin-bottom: 10px; /* 移动端增加间距 */
  }

  .fhdl {
    display: inline-block; /* 改为 inline-block 以适应移动端 */
    color: #777777;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
  }

.fhdl:hover {
  text-decoration: underline;
}

.login-text {
  color: #BA0B0B;
  font-weight: bold;
}

  .registerBox {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 10px; /* 增加底部间距 */
  }


.zx_mr_box {
  position: fixed;
  right: 40px;
  bottom: 200px;
  font-size: 100px;
  background-image: url(../../assets/index/zx-mr.png);
  background-size: 100% 100%;
  width: 54px;
  height: 54px;
}

.zx_xf_box {
  position: fixed;
  right: 40px;
  bottom: 200px;
  font-size: 100px;
  background-image: url(../../assets/index/zx-xf.png);
  background-size: 100% 100%;
  width: 54px;
  height: 54px;
}

.zx_qr_box {
  position: fixed;
  right: 120px;
  bottom: 150px;
  width: 100px;
  height: 120px;
  border: 10px solid white;
  background-color: white;
  color: #7E7E7E;

}
.verification-img{
  line-height: 64px;
}
</style>
